import Client from './client';
import { API_BASE } from './config';
import { getToken, useAuthStore } from '../stores/authStore';

// Create a singleton client instance
// Auth is provided dynamically from the auth store
export const client = new Client(API_BASE as any, {
  auth: () => {
    const token = getToken();
    return {
      authorization: token ? `Bearer ${token}` : '',
      tenantId: '', // tenantId is embedded in the JWT
    };
  },
});

// Export for direct access to typed service clients
export const { chat, zoom: account, connection, database, planner, planning, validation, graph_docs, report } = client;

// Alias for graph_docs with camelCase
export const graphDocs = graph_docs;

// =============================================================================
// Global 401 interceptor
// =============================================================================

const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  if (response.status === 401 && getToken()) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] as Request)?.url ?? '';
    if (url.startsWith(API_BASE)) {
      console.warn('[401 interceptor] Got 401 from:', url, '— clearing token');
      // Clear token but don't hard-redirect — let ProtectedRoute handle it
      useAuthStore.setState({ token: null, user: null, hasZoomConnection: false });
    }
  }
  return response;
};
